<template>
  <div>
    <h1>404 - NotFound</h1>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
};
</script>